// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community/util': []
})(this, function (m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Util = M.Community.View.Util || {};

  /**
   * @class M.Community.View.Util.ListPanel
   *
   * This class creates a panel that takes in a list of views and renders
   * its items within a parent container div.
   * This div takes in a title, a list of views to render, and parameters
   * for a ShowHide panel
   */
  M.Community.View.Util.ListPanel = Backbone.View.extend({
    template: M.Template.Community.Util.ListPanel,

    options: {
      buttonText: ""
    },

    initialize: function() {
      M.required(this.options.list);
      this.$el = $(this.el);
      this._createPanel();
    },

    render: function() {
      this.$el.html(this.template(this.options));

      var container = this.$el.find('.listPanel');
      _.each(this.options.list, function(viewItem) {
        $(container).append(viewItem.render().el);
      });

      var buttonDiv = this.$el.find('.buttonContainer .button');
      buttonDiv.addClass(this.options.buttonClass);
      return this;
    },

    _renderShowHidePanel: function() {
      var $container = this.$el.find('.listPanel');
      this.showHidePanel = new M.Community.View.Util.ShowHide({
        numObjectsToShow: this.options.numObjectsToShow,
        classToFilter: this.options.listItemClass,
        pageClass: this.options.pageClass,
        itemsParentPanelEl: $container,
        shouldToggleHeader: this.options.shouldToggleHeader
      });
    },

    _createPanel: function() {
      var $parentContainer = this.options.parentContainer;
      this.render();
      $parentContainer.append(this.$el);
      this._renderShowHidePanel();
      this.showHidePanel.$el.insertAfter($parentContainer);
    }

  });

  return {
  };

});
